module.exports = __webpack_public_path__ + "img/audio-play3.34fa21ef.png";